import { Box, Drawer } from "@mui/material"
import { Outlet, createFileRoute, redirect, useLocation } from "@tanstack/react-router"
import { twMerge } from "tailwind-merge"

import { Notifications } from "@/components/common/Notifications/Notifications"
import SideNav from "@/components/SideNav/SideNav"
import { useAppView } from "@/hooks/useAppView"
import { useCurrentUserStore } from "@/stores/currentUserStore"
import { useSideNavStore } from "@/stores/useSideNavStore"

const SIDEBAR_EXPANDED_WIDTH = 300
const SIDEBAR_COLLAPSED_WIDTH = 88

export const beforeLoad = async (): Promise<void> => {
  const store = useCurrentUserStore.getState()
  const user = await store.getCurrentUser()

  if (user && !user.isActive) {
    throw redirect({ to: "/deactivated" })
  }

  // TEMPORARY DISABLED FOR TESTING PURPOSES
  // props should contain { location }: { location: ParsedLocation }
  // const hasTabletPermission = user?.permissions?.includes(PermissionActionType.WAREHOUSE_TABLET_ONLY)
  // const isTabletRoute = location.pathname.includes("/app/tablet")

  // if (hasTabletPermission && !isTabletRoute) {
  //   throw redirect({ to: "/app/tablet/warehouse-receiving/incoming" })
  // }
}

export const Route = createFileRoute("/app")({
  beforeLoad,
  component: AppComponent,
})

function AppComponent() {
  const { shouldShowSideNav } = useAppView()
  const isCollapsed = useSideNavStore((state) => state.isCollapsed)
  const drawerWidth = isCollapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_EXPANDED_WIDTH
  const location = useLocation()
  const isDashboard = location.pathname.startsWith("/app/dashboard")

  return (
    <>
      {shouldShowSideNav && (
        <Drawer
          classes={{ paperAnchorLeft: "border-0", paper: "bg-transparent" }}
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            transition: "width 0.2s ease",
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
              transition: "width 0.2s ease",
              overflowX: "hidden",
            },
          }}
          variant='permanent'
          anchor='left'
        >
          <SideNav isCollapsed={isCollapsed} />
        </Drawer>
      )}
      <main className='flex grow flex-col overflow-hidden py-4 pr-4'>
        <Box className={twMerge("flex flex-1 overflow-hidden rounded-xl", isDashboard ? "bg-transparent" : "bg-white")}>
          <Box className='flex flex-1 flex-col overflow-y-auto p-6'>
            <Outlet />
          </Box>
        </Box>
      </main>
      <Notifications />
    </>
  )
}
